export const EMAIL_KEY_LS = 'enteredEmail';
